module.exports = __webpack_public_path__ + "img/jobmule_skill_category.1cf0358f.png";